import script from "./CarouselImg.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarouselImg.vue?vue&type=script&lang=ts&setup=true"

import "./CarouselImg.vue?vue&type=style&index=0&id=5e0d8757&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0d8757"]])

export default __exports__